import React from 'react';
import { useTranslation } from 'react-i18next'; // Hook for translations
import { Link } from 'react-router-dom'; // For navigation

const GeographicalNames = () => {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div className="digital-twin-page">
      <section className="container section">
        {/* Overview */}
        <h2>{t('overview-title')}</h2>
        <p>{t('overview-description')}</p>

        {/* Goal */}
        <h3 style={{ color: '#73BF93' }}>{t('goal-title')}</h3>
        <p>{t('goal-description')}</p>

        {/* Key Tasks */}
        
        <ul>
          <li>{t('task1')}</li>
          <li>{t('task2')}</li>
          <li>{t('task3')}</li>
          <li>{t('task4')}</li>
        </ul>

        {/* Key Responsibilities */}
        <h3 style={{ color: '#73BF93' }}>{t('responsibilities-title')}</h3>
        <p>{t('responsibility1')}</p>
        <ul>
          <li>{t('responsibility2')}</li>
          <li>{t('responsibility3')}</li>
          <li>{t('responsibility4')}</li>
          <li>{t('responsibility5')}</li>
        </ul>

        {/* Completed Works */}
        <p>{t('committee-works-title')}</p>

        {/* Link to Geographical Names Explorer */}
        <div className="container text-center">
          <Link to={t('geographical_names_explorer_url')}>
            <button className="geospatial-button" id="readMoreBtn">
              {t('Open_App')}
            </button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default GeographicalNames;
